<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>About MicroSync Technologies</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>About MicroSync Technologies</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- About -->
<section class="about-area ptb-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="about-image-warp"></div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-content warp">
                    <span>About Us</span>
                    <div class="bar"></div>
                    <p>
                        MicroSync Technologies is one of the key strategic partners to various leading
                        Banking, Financial, Insurance and Retail Institutions providing cutting edge Solutions and
                        Consulting around Digital
                        Transformation, AI, IoT, Big data, RPA along with conventional IT services. Our teams specialize
                        in building robust
                        solutions that enable intelligent actions and accelerated business outcomes for various
                        enterprises.

                        MicroSync Technologies are the niche
                        providers of Software Solutions & Services with expertise in Testing Services, Development
                        Services, Resource Management Services, Data Fusion Analytics, Complex
                        Software Integrations, Cyber
                        Security, Block Chain, Big Data & Internet of Things (IoT). We strive to help our Customers by
                        leveraging our
                        well-managed IT services that leaves Customers to focus on nothing but their Core Business
                    </p>
                    <div class="about-inner-content">
                        <div class="icon">
                            <i class="flaticon-check"></i>
                        </div>
                        <h4>Our Vision</h4>
                        <p>“Inspired to Serve" guides us in all the activities that we do. Our culture begins with a
                            commitment to each
                            other, teamwork, innovation, and collaboration. This collective energy is then focused on
                            providing our clients with
                            innovative solutions to their most pressing challenges.</p>
                    </div>
                    <div class="about-inner-content">
                        <div class="icon">
                            <i class="flaticon-check"></i>
                        </div>
                        <h4>Our Mission</h4>
                        <p>To deliver State of the Art Technology Solutions to our Customers through disruptive
                            Innovation and to provide a
                            Progressive Platform to our Employees to Achieve Excellence in this quickly transforming
                            world.</p>
                    </div>

                    <div class="about-inner-content">
                        <div class="icon">
                            <i class="flaticon-check"></i>
                        </div>
                        <h4>Our Values</h4>
                        <p>
                            <li>Customer Centricity – is the ability of people in an organization to understand
                                customers' situations, perceptions,
                                and expectations.</li>
                            <li>Integrity - we display the highest levels of honesty and moral principles in all
                                dealings with our employees, business partners, and
                                customers.</li>
                            <li>Innovation – we provide new ideas, creative thoughts, and new insights in all our
                                efforts and for the benefit of our
                                customers.</li>
                            <li>Agility – we maintain maximum flexibility to adapt and respond to our customers’ most
                                demanding challenges and changing
                                needs.</li>
                            <li>Collaboration – we maintain an inclusive, team-oriented, and proactively environment to
                                stay connected with each other.</li>
                            <li>Commitment – we are fully accountable to our customers and our partners, taking
                                ownership, exhibiting model servant
                                leadership, and operating with a sense of urgency.</li>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End About -->